import React from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';
import ChangePassword from './change-password';

const UI = ({ match }) => (
    <Switch>
        <Route path={`${match.url}/change-password`} component={ChangePassword} />
        <Redirect to="/error" />
    </Switch>

);
export default UI;
